export default {
    "tracker": "Навигатор эмоций",
    "diary": "Дневник Эмоций",
}